export default __webpack_public_path__ + "static/media/leftArrow.7c8e0d80.svg";